import React from 'react';

import Field, { hasDataInFields } from './Field';

const FieldMedia = props => {
  const { className, imageClassName, media, sizes, options } = props;

  const hasMediaField = hasDataInFields([media], options);

  if (!hasMediaField) {
    return null;
  }

  return (
    <div className={className}>
      <Field data={media} sizes={sizes} options={options} imageClassName={imageClassName} />
    </div>
  );
};

export default FieldMedia;
